import {
  ClinicalReport,
  GetClinicalReportAction,
} from '../actions/clinicalReport';

const initialBuildsState: ClinicalReport = 'Disabled';

export const clinicalReportReducer = (
  state: ClinicalReport = initialBuildsState,
  action: GetClinicalReportAction
): ClinicalReport => {
  switch (action.type) {
    case 'GOT_CLINICAL_REPORT':
      return action.payload;
    default:
      return state;
  }
};
